import React, { useCallback, useEffect, useState } from 'react'
import useReport from '../../utils/hooks/useReport'
import { APIEndpoints } from '../../utils/api/apiConfig'
import { useNavigate } from 'react-router-dom'
import ArraySelect from '../Select/ArraySelect'
import { t } from 'i18next'
import { Alert, Form } from 'react-bootstrap'
import DownloadURLAlert from '../Forms/DownloadURLAlert'
import { useCancelToken } from '../../utils/hooks/useCancelToken'
import { makeCall } from '../../utils/api/makeCall'
import apiClient from '../../utils/api/apiClient'
import ReportSubscriptionModal from '../Files/Form/ReportSubscriptionModal'

const ActionSelect = ({ selectedRow }) => {
  const {
    reportErrors,
    reportDownloadUrls,
    setReportDownloadUrls,
    reportSubscriptionId,
    setReportSubscriptionId,
  } = useReport()
  const [assetInfo, setAssetInfo] = useState(null)
  const { createOrCancelToken, sourceRef, isCancel } = useCancelToken()
  const [, setError] = useState({})
  const [, setLoading] = useState({})
  const navigate = useNavigate()

  const getAssetInfo = useCallback(() => {
    createOrCancelToken()
    makeCall(
      'getInfo',
      async () => {
        let data = await apiClient.getJson(
          APIEndpoints.assets(selectedRow.id).info,
          null,
          true,
          false,
          true,
          { cancelToken: sourceRef.current.token }
        )
        setAssetInfo(data)
      },
      setError,
      setLoading,
      isCancel
    )
  }, [createOrCancelToken, isCancel, selectedRow.id, sourceRef])

  useEffect(() => {
    if (selectedRow) {
      setAssetInfo(null)
      getAssetInfo()
    }
    return () => {
      setError('')
    }
  }, [getAssetInfo, selectedRow])

  const actionNames = {
    order: t('assetPage:equipAsset'),
    orderHistory: t('orders'),
    printInventory: t('assetPage:currentEquipment'),
    printOrderHistory: t('assetPage:orderHistory'),
    inventoryBooking: t('assetPage:inventoryBooking'),
  }

  const handleChangeAction = (e) => {
    let actionName = e.target.value
    if (actionName !== '') {
      let path = ''
      switch (actionName) {
        case 'assetInventoryBooking':
          path = `/inventoryAction/assets/${selectedRow.id}`
          navigate(path)
          break
        case 'printInventory':
          path = `/inventory/${selectedRow.id}`
          navigate(path)
          break
        case 'printOrderHistory':
          path = `/inventoryHistory/${selectedRow.id}`
          navigate(path)
          break
        case 'order':
          path = `/products/asset/${selectedRow.id}`
          navigate(path)
          break
        case 'orderHistory':
          path = `/asset-orders/${selectedRow.id}`
          navigate(path, {
            state: {
              selectedStatus: 'open',
            },
          })
          break
        default:
          break
      }
    }
  }
  return (
    <div>
      {reportErrors.reportName && (
        <Alert variant='danger'>{reportErrors.reportName.value}</Alert>
      )}

      {reportDownloadUrls.reportName && (
        <DownloadURLAlert
          downloadUrl={reportDownloadUrls.reportName}
          setDownloadUrl={() => setReportDownloadUrls({})}
          fileName={t('employeesPage:accountBallance')}
        />
      )}
      {reportSubscriptionId && (
        <ReportSubscriptionModal
          reportSubscriptionId={reportSubscriptionId}
          setReportSubscriptionId={setReportSubscriptionId}
          message={t('reportConfig:createPending')}
        />
      )}
      <Form.Group className='mb-3'>
        <ArraySelect
          defaultOption={{ value: '', name: t('selectAction') }}
          options={
            assetInfo
              ? assetInfo.allowedActions.map((item) => ({
                  id: item,
                  displayName: actionNames[item],
                }))
              : []
          }
          onChange={handleChangeAction}
          returnEvent
        />
      </Form.Group>
    </div>
  )
}

export default ActionSelect
